import { motion } from 'framer-motion'
import { Handle, Position } from 'reactflow'
import React from 'react'
import { useAudienceFlowDiagramState } from '../../Audiences/AudienceDetails/AudienceFlowDiagram'
import classNames from 'classnames'
import { useAudienceMetricsState } from '../../../pages/Dashboard/Dealer/Audiences/Audience/AudienceDetails'
import { useSearchParams } from 'react-router-dom'

const AudienceNode = (props: { id: string }) => {
  const { selectedNode, setSelectedNode } = useAudienceFlowDiagramState()
  const isSelected = selectedNode?.id === props?.id
  const className = classNames(
    'shadow-md rounded-full border-primary-xiketic border-2 px-5 py-3 font-bold nodrag',
    {
      'text-white bg-primary-xiketic': isSelected,
      'text-primary-xiketic bg-white': !isSelected,
    },
  )
  const { setFilters } = useAudienceMetricsState()
  const [searchParams, setSearchParams] = useSearchParams()
  return (
    <motion.div
      whileHover={{
        scale: 1.1,
      }}
      whileTap={{ scale: 1.085 }}
      onClick={() => {
        searchParams.delete('campaign_id')
        setSearchParams(searchParams)
        setSelectedNode(props)
        setFilters((prev) => ({
          ...prev,
          vendor_account_id: undefined,
        }))
      }}
      className={className}>
      <div>This audience</div>
      <Handle type="target" position={Position.Left} className="" />
      <Handle type="source" position={Position.Right} className="" />
    </motion.div>
  )
}

export default AudienceNode
